module.exports = __webpack_public_path__ + "img/profile_avatar_1.7a21dab1.svg";